'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function pickBy(obj, shouldPick) {
    var result = {};
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var value = obj[key];
        if (shouldPick(value, key)) {
            result[key] = value;
        }
    }
    return result;
}
exports.pickBy = pickBy;
